import { createSlice } from '@reduxjs/toolkit'
import {
  formSatisfied,
  getLandingUrlDto,
  getLandingUrlState,
} from 'features/creative/creativeUtil'
import { validateLandingUrlWithSiteUrl } from 'features/creative/add/common/useCreativeValidation'

const initialState = {
  links: [
    {
      text: '',
      landingUrl: {
        individual: false,
        mobileUrl: '',
        pcUrl: '',
      },
    },
    {
      text: '',
      landingUrl: {
        individual: false,
        mobileUrl: '',
        pcUrl: '',
      },
    },
    {
      text: '',
      landingUrl: {
        individual: false,
        mobileUrl: '',
        pcUrl: '',
      },
    },
    {
      text: '',
      landingUrl: {
        individual: false,
        mobileUrl: '',
        pcUrl: '',
      },
    },
  ],
}

export const isFilledLink = link =>
  link.text !== '' &&
  (link.landingUrl.individual
    ? link.landingUrl.mobileUrl !== '' || link.landingUrl.pcUrl !== ''
    : link.landingUrl.mobileUrl !== '')

export const isEmptyLink = link =>
  link.text === '' &&
  link.landingUrl.mobileUrl === '' &&
  link.landingUrl.pcUrl === ''

export const validateAdditionalLink = (active, state, siteUrl) => ({
  links: state.links.map((e, i) => {
    if (i === 3) {
      if (!formSatisfied(i, state.links, isFilledLink) || isEmptyLink(e)) {
        return { text: false, mobileUrl: false, pcUrl: false }
      } else {
        return {
          text: active && e.text === '' && '내용을 입력하세요.',
          ...(active && validateLandingUrlWithSiteUrl(e.landingUrl, siteUrl)),
        }
      }
    }
    return {
      text:
        active &&
        e.text === '' &&
        '최소 3개의 부가링크가 필요합니다. 내용을 입력하세요.',
      ...(active && validateLandingUrlWithSiteUrl(e.landingUrl, siteUrl)),
    }
  }),
})

export const getAdditionalLinkAssetData = state => ({
  type: 'ADDITIONAL_LINK',
  data: {
    links: state.links
      .filter(link => isFilledLink(link))
      .map(({ text, landingUrl }) => ({
        landingUrl: getLandingUrlDto(landingUrl),
        text,
      })),
  },
})

const additionalLinkSlice = createSlice({
  name: 'additionalLink',
  initialState,
  reducers: {
    reset: () => initialState,
    setText: (state, { payload: { index, text } }) => {
      state.links[index].text = text
    },
    setAllIndividualChecked: (state, { payload: individual }) => {
      state.links.forEach(link => {
        link.landingUrl.individual = individual
      })
    },
    setIndividualChecked: (state, { payload: { index, checked } }) => {
      state.links[index].landingUrl.individual = checked
    },
    setMobileUrl: (state, { payload: { index, url } }) => {
      state.links[index].landingUrl.mobileUrl = url
    },
    setPcUrl: (state, { payload: { index, url } }) => {
      state.links[index].landingUrl.pcUrl = url
    },
    setAdditionalLink: (state, { payload: { links } }) => {
      links.forEach(({ landingUrl, text }, index) => {
        state.links[index] = {
          text,
          landingUrl: getLandingUrlState(landingUrl),
        }
      })
    },
  },
})

export const {
  reset,
  setText,
  setAllIndividualChecked,
  setIndividualChecked,
  setMobileUrl,
  setPcUrl,
  setAdditionalLink,
} = additionalLinkSlice.actions

export default additionalLinkSlice.reducer
